import Loader from '@/components/Loader/Loader';
import { useAuth } from '@/auth/Auth';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function ImpToken() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { replaceSession } = useAuth();
  const token = searchParams.get('token');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) return;

    let isActive = true;

    const loginWithImpersonation = async () => {
      let decodedToken = '';

      try {
        decodedToken = decodeURIComponent(atob(token));
      } catch (e) {
        if (isActive) {
          setError('Token inválido. Por favor, verifique o link.');
        }
        return;
      }

      try {
        await replaceSession(decodedToken);
        navigate('/dashboard', { replace: true });
      } catch (e) {
        if (isActive) {
          setError('Nao foi possivel carregar a conta. Gere um novo link e tente novamente.');
        }
      }
    };

    void loginWithImpersonation();

    return () => {
      isActive = false;
    };
  }, [token, replaceSession, navigate]);

  if (error) {
    return (
      <div style={{ color: 'red', textAlign: 'center', marginTop: 40 }}>
        {error}
      </div>
    );
  }

  return <Loader fullScreen />;
}
